export default __webpack_public_path__ + "static/media/Roger.40545b71.gif";